import { render, staticRenderFns } from "./DepartmentUpdateModal.vue?vue&type=template&id=f65baac4&scoped=true&"
import script from "./DepartmentUpdateModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentUpdateModal.vue?vue&type=style&index=0&id=f65baac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65baac4",
  null
  
)

export default component.exports